<template>
  <div class="header">
	<router-link :to="url" class="back">
		<img src="@/assets/images/back.png" alt="">
	</router-link>
	<!-- <div class="back" @click="back">
		<img src="@/assets/images/back.png" alt="">
	</div> -->
  </div>
</template>

<script>
export default {
  name: 'HeaderMobile',
  props: {
    url: String
  },
  data() {
    return {
		
	}
  },
  methods: {
	  back(){
		  this.$router.back()
	  }
  },
  
}
</script>
<style scoped>
	.header{background: #fff;overflow: hidden;height: 0.8rem;}
	.header .back{text-align: center;width: 0.8rem;height: 0.8rem;float: left;display: block;}
	.header .back img{width: 0.25rem;height: 0.44rem;vertical-align: top;margin-top: 0.18rem;}
</style>
